import { FC } from 'react'

import { IconPageText } from '@sequencehq/core-components'

import { NodeIconTemplate } from 'Automations/nodeDefinitions/components'
import { IconProps } from '../../types'

export const NoteIcon: FC<IconProps> = ({ boxSize, theme = 'yellow' }) => {
  return (
    <NodeIconTemplate icon={<IconPageText />} theme={theme} boxSize={boxSize} />
  )
}
